import { StoppableMarker } from '@components/common/atoms';
import { useStopPoints } from '@data/fms/stopPoint/hooks';
import type { StopPoint } from '@data/fms/stopPoint/types';
import { memo, useMemo } from 'react';

type Props = {
  stopPoints?: StopPoint[];
};

const StopPointMarkers: React.FC<Props> = ({ stopPoints }) => {
  const { stopPoints: defaultStopPoints } = useStopPoints();

  const displayStopPoints = useMemo(
    () => (!stopPoints ? defaultStopPoints : stopPoints),
    [defaultStopPoints, stopPoints],
  );

  if (displayStopPoints.length === 0) return null;

  return (
    <>
      {displayStopPoints.map((stopPoint) => (
        <StoppableMarker key={stopPoint.point_id} data={stopPoint} />
      ))}
    </>
  );
};

export default memo(StopPointMarkers);
